// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wifi-off-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.7773 12.7777L21.9955 7.50495C18.3216 4.55846 13.6497 3.46976 9.23828 4.23873M15.5554 15.5558L5.41363 5.41406C4.2138 5.95559 3.06706 6.6527 2.00391 7.50536L11.9998 20.0003L15.5554 15.5558Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 3L21 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WifiOff1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi-off-1',
    ref,
    icon: element,
  },
));

WifiOff1Icon.displayName = 'WifiOff1Icon';

export default WifiOff1Icon;
